import { Facebook, Instagram, Linkedin, Mail, Phone, Printer, Twitter } from "lucide-react";
import { NavigationWeb } from "../NavigationWeb";

const quickLinks = [
    { id: "1", label: "Company Profile", href: "/about-us" },
    { id: "2", label: "Vehicle Inventory", href: "/inventory" },
    { id: "3", label: "Privacy Policy", href: "/privacy-policy" },
];

const socials = [
    { id: "instagram", label: "Instagram", href: "#", Icon: Instagram },
    { id: "facebook", label: "Facebook", href: "#", Icon: Facebook },
    { id: "twitter", label: "Twitter", href: "#", Icon: Twitter },
    { id: "linkedin", label: "LinkedIn", href: "#", Icon: Linkedin },
];

function FooterComponent() {
    return (
        <section id='footer'>
            <div className='px-4 md:px-32 mt-12 py-14 bg-gray-100'>
                <div className='grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4'>
                    {/* Brand */}
                    <div className='flex flex-col gap-5'>
                        <img src='/logo192.png' alt='Logo' className='w-16' />
                        <p className='text-sm leading-relaxed text-gray-500'>
                            We deliver premium, fully-inspected Japanese vehicles worldwide. Enjoy a transparent
                            process, detailed documentation, and secure delivery. Browse our collection, review each
                            car's specs, and get in touch.
                        </p>
                        <div className='flex flex-row gap-3'>
                            {socials.map(({ id, label, href, Icon }) => (
                                <a
                                    key={id}
                                    href={href}
                                    aria-label={label}
                                    className='flex h-10 w-10 items-center justify-center rounded-lg bg-purple-600 text-white duration-150 hover:bg-purple-700'>
                                    <Icon className='h-5 w-5' />
                                </a>
                            ))}
                        </div>
                    </div>

                    {/* Quick Links */}
                    <div className='flex flex-col gap-4 text-sm'>
                        <span className='text-base font-semibold text-slate-950'>Quick Links</span>
                        <div className='flex flex-col gap-3'>
                            {quickLinks.map((link) => (
                                <a key={link.id} href={link.href} className='text-gray-500 duration-150 hover:text-purple-600'>
                                    {link.label}
                                </a>
                            ))}
                        </div>
                    </div>

                    {/* Contact */}
                    <div className='flex flex-col gap-4 text-sm'>
                        <span className='text-base font-semibold text-slate-950'>Contact Us</span>
                        <p className='leading-relaxed text-gray-500'>
                            2-8-1 Nishi-Shinjuku, Shinjuku-Ku, Tokyo 160-0023, Japan
                        </p>
                        <a href='tel:+819063999666' className='flex flex-row items-center gap-3 text-gray-500 duration-150 hover:text-purple-600'>
                            <Phone className='h-4 w-4 shrink-0 text-purple-600' />
                            +81-090-6399-9666
                        </a>
                        <a href='mailto:atech.jp' className='flex flex-row items-center gap-3 text-gray-500 duration-150 hover:text-purple-600'>
                            <Mail className='h-4 w-4 shrink-0 text-purple-600' />
                            atech.jp
                        </a>
                    </div>

                    {/* Newsletter */}
                    <div className='flex flex-col gap-4 text-sm'>
                        <span className='text-base font-semibold text-slate-950'>Newsletter</span>
                        <p className='leading-relaxed text-gray-500'>
                            Subscribe to receive the latest listings and exclusive offers.
                        </p>
                        <form
                            className='flex flex-row'
                            onSubmit={(e) => e.preventDefault()}>
                            <input
                                type='email'
                                placeholder='Enter your email'
                                className='w-full rounded-l-lg border border-gray-300 border-r-0 px-3 py-2 text-sm text-slate-950 outline-none focus:border-purple-600'
                            />
                            <button
                                type='submit'
                                className='shrink-0 rounded-r-lg bg-purple-600 px-4 py-2 text-sm font-semibold text-white duration-150 hover:bg-purple-700'>
                                Subscribe
                            </button>
                        </form>
                    </div>
                </div>
            </div>
            <div className='px-4 md:px-32'>
                <NavigationWeb />
            </div>
        </section>
    );
}

export default FooterComponent;
